import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
import { isValidElement, Children } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import UIRouterNavLink from './UIRouterNavLink';
import useIsActive from './internal/useIsActive';
import { cloneDefaultProps, clonePropTypes } from './internal/utils';
const sideNavPropKeys = Object.keys(clonePropTypes(UISideNavItem));

function pickSideNavItemProps(props) {
  const sideNavProps = {};

  for (const propKey of sideNavPropKeys) {
    if (props.hasOwnProperty(propKey)) {
      sideNavProps[propKey] = props[propKey];
    }
  }

  return sideNavProps;
}

const UIRouterSideNavLeaf = props => {
  const {
    to,
    exact = false,
    experimental_matchSearchExact
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["to", "exact", "experimental_matchSearchExact"]);

  const active = useIsActive(to, exact, experimental_matchSearchExact);
  return /*#__PURE__*/_jsx(UISideNavItem, Object.assign({}, rest, {
    to: to,
    exact: exact,
    active: active,
    linkComponent: UIRouterNavLink
  }));
};

const UIRouterSideNavNode = props => {
  const location = useLocation();
  const {
    children
  } = props;
  let hasActiveChild = false;
  Children.forEach(children, element => {
    if (!hasActiveChild && /*#__PURE__*/isValidElement(element)) {
      const {
        to,
        exact = false,
        strict = false
      } = element.props;
      const path = typeof to === 'object' ? to.pathname : to;
      hasActiveChild = !!matchPath(location.pathname, {
        path,
        exact,
        strict
      });
    }
  });
  const defaultOpen = props.defaultOpen == null ? hasActiveChild : props.defaultOpen;
  return /*#__PURE__*/_jsx(UISideNavItem, Object.assign({
    active: hasActiveChild
  }, pickSideNavItemProps(props), {
    defaultOpen: defaultOpen
  }));
};

const UIRouterSideNavItem = props => {
  const {
    to,
    children
  } = props;

  if (to == null && children) {
    return /*#__PURE__*/_jsx(UIRouterSideNavNode, Object.assign({}, props));
  }

  return /*#__PURE__*/_jsx(UIRouterSideNavLeaf, Object.assign({}, props));
};

UIRouterSideNavItem.propTypes = Object.assign({}, UIRouterNavLink.propTypes, {}, clonePropTypes(UISideNavItem));

const _cloneDefaultProps = cloneDefaultProps(UISideNavItem),
      sanitizedUISideNavItemDefaultProps = _objectWithoutPropertiesLoose(_cloneDefaultProps, ["defaultOpen"]);

UIRouterSideNavItem.defaultProps = Object.assign({}, UIRouterNavLink.defaultProps, {}, sanitizedUISideNavItemDefaultProps, {
  exact: true
});
export default UIRouterSideNavItem;